import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";

const getListProfiles = async ({ token, callbacks }) => {
    const response = await connection({ method: 'GET', url: `${ENTITY_URL.TIPO_PERSONA.LIST}`, extraHeaders: { token: token } });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}
export default getListProfiles;